module.exports = __webpack_public_path__ + "img/gs.gs70cddc0.svg";